import useMediaQuery from '@material-ui/core/useMediaQuery';
import { Theme } from '@material-ui/core/styles';

export function useIsMobile(): boolean {
  return useMediaQuery<Theme>((theme) => theme.breakpoints.down(`sm`));
}
